import { Ref } from 'vue';
import { ISupportData, ISupportState } from './models';
import { httpClient } from '@/core/axios/http-client';

const useStoreActions = (state: Ref<ISupportState>) => {
  const API_PREFIX = 'support';

  const getSupportData = () => {
    return httpClient.get<void, ISupportData>(`${API_PREFIX}/data`).then((response) => {
      state.value.data = response;
    });
  };

  const save = (data: ISupportData) => {
    return httpClient.post<void, ISupportData>(`${API_PREFIX}/save`, data).then((response) => {
      return response;
    });
  };

  return {
    getSupportData,
    save,
  };
};

export default useStoreActions;
